import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaDo_1.mjs'
import FormChoose from './FormChooseDo_1.jsx'
import TableChoose from './TableChooseDo_1.jsx'
import api from './apiDo_1.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
    })
}
